import { connect } from 'react-redux';
import { baseDomain } from '../../../../../core/selectors/institution';
import {
  accessingCurrentSpaceAsStaff,
  isInstructorInSpace,
} from '../../../../../core/selectors/classroom';
import fetchAccessTokenAction from '../../../../../core/actions/accessToken/accessToken.action';
import {
  operations as assignmentOperations,
  selectors as assignmentSelectors,
} from '../../../../store/assignments';
import {
  currentUserId,
  needsToRefreshAccessToken,
} from '../../../../../core/selectors/user';
import AssignmentsResponsive from './AssignmentResponsive';

export const mapStateToProps = (state) => {
  const userId = currentUserId(state);
  const spaceId = assignmentSelectors.getSelectedSpaceId(state);

  const needsToRefreshAccessTokenProp = () => {
    return spaceId ? needsToRefreshAccessToken(state, spaceId) : false;
  };
  const isStaff = accessingCurrentSpaceAsStaff(state);

  return {
    user: state.user.user,
    selectedSpace: spaceId ? state.data.classRooms[spaceId] : undefined,
    isFetching:
      assignmentSelectors.isFetchingAssignments(state) ||
      state.accessTokens.isFetching,
    accessTokens: state.accessTokens,
    baseDomain: baseDomain(state),
    isEducator: spaceId ? isInstructorInSpace(state)(userId, spaceId) : false,
    needsToRefreshAccessTokenProp,
    isStaff,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  fetchAssignments: dispatch(assignmentOperations.fetchAssignments),
  fetchAccessToken: fetchAccessTokenAction(dispatch),
});

const AssignmentsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignmentsResponsive);

export default AssignmentsContainer;
